import React, { useEffect, useState } from 'react'
import { useAboutUsStore } from '../../store/useAboutUs'
import Loader from '../../Components/Loader'
import { useNavigate } from 'react-router'

const Mission = () => {
    const [data, setData] = useState({
        subTitle: '',
        title: '',
        description: '',
        images: []
    })

    const { mission, postMission } = useAboutUsStore()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (mission) {
            setData({
                subTitle: mission?.subTitle || '',
                title: mission?.title || '',
                description: mission?.description || '',
                images: mission?.images,
                buttonText: mission?.buttonText || ''
            })
        }
    }, [mission])

    const getImageSrc = (img) => {
        if (!img) return null;

        if (typeof img === "string") {
            return img;
        }

        if (img instanceof File || img instanceof Blob) {
            return URL.createObjectURL(img);
        }

        return null;
    };


    const handleChange = (e) => {
        const { name, value } = e.target
        setData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSubmit = async () => {
        setLoading(true)
        await postMission(data)
        setLoading(false)
    }

    return (
        <div id="story-section" className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6">
            <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
                <h3>Our Mission</h3>
            </div>
            <Loader loading={loading}>
                <div className="p-6">
                    <div className="grid grid-cols-1 gap-6">
                        <div>
                            <label className="block text-sm text-neutral-700 mb-2">Section SubTitle</label>
                            <input
                                type="text"
                                name="subTitle"
                                value={data.subTitle}
                                onChange={handleChange}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />

                            <label className="block text-sm text-neutral-700 mb-2">Section Title</label>
                            <input
                                type="text"
                                name="title"
                                value={data.title}
                                onChange={handleChange}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />

                            <label className="block text-sm text-neutral-700 mb-2">Button Text</label>
                            <input
                                type="text"
                                name="buttonText"
                                value={data.buttonText}
                                onChange={handleChange}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />

                            <label className="block text-sm text-neutral-700 mb-2">Description</label>
                            <textarea
                                rows="8"
                                name="description"
                                value={data.description}
                                onChange={handleChange}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                            <div className="mb-6">
                                <label className="block text-sm text-neutral-700 mb-2">Image</label>
                                <div className="border-2 border-dashed border-neutral-300 rounded-md p-6 flex flex-col items-center justify-center">
                                    <i className="fa-solid fa-cloud-upload-alt text-3xl text-neutral-400 mb-2"></i>
                                    <p className="text-neutral-600 mb-2">Drag and drop an image here, or click to browse</p>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => setData({
                                            ...data,
                                            images: e.target.files[0]
                                        })}

                                        className="hidden"
                                        id="projectImage"
                                    />
                                    <label
                                        htmlFor="projectImage"
                                        className="px-4 py-2 bg-neutral-100 text-neutral-700 rounded-md text-sm cursor-pointer"
                                    >
                                        Select File
                                    </label>
                                    {data?.images && <p className="mt-2 text-sm text-green-600">{data?.images.name}</p>}
                                    <div className="w-44 h-26 flex items-center justify-center text-white text-xs mr-4">
                                        {getImageSrc(data?.images) ? (
                                            <img
                                                src={getImageSrc(data?.images)}
                                                alt="Hero"
                                                className="w-full h-full object-cover"
                                            />
                                        ) : (
                                            'No Image'
                                        )}
                                    </div>
                                </div>
                                <span className='text-sm font-medium text-gray-700'>Recomended Image Size : 460px*630px</span>
                            </div>
                        </div>


                    </div>
                    <div className="flex justify-end space-x-3 mt-8">
                        <button className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md"
                            onClick={() => navigate(-1)}
                        >Cancel</button>
                        <button
                            className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                            onClick={() => handleSubmit()}
                        >
                            Save Mission
                        </button>
                    </div>
                </div>
            </Loader>
        </div>
    )
}

export default Mission
